export default "/images/Farblabor.gif?bfc421030df106cd4f752f652245a6b5";